import * as React from 'react'

import { AlertDialogSlide } from '@sales-center/components'

import { DELETE_DISABLE_COVERAGE_TITLE } from '../constants'
import { getDeleteDisableCoverageMessage } from '../utils/coverageError'

type Props = {
  labels: string[] | null
  onClose: () => void
}

export function CoverageBlockDialog(props: Props) {
  const { labels, onClose } = props

  return (
    <AlertDialogSlide
      title={DELETE_DISABLE_COVERAGE_TITLE}
      message={labels ? getDeleteDisableCoverageMessage(labels) : ''}
      open={!!labels}
      disableDelete
      cancelButtonText="Close"
      cancelClick={onClose}
    />
  )
}

CoverageBlockDialog.displayName = 'CoverageBlockDialog'
